import { render, staticRenderFns } from "./PermissionsErrorItem.vue?vue&type=template&id=34100088"
import script from "./PermissionsErrorItem.vue?vue&type=script&lang=ts"
export * from "./PermissionsErrorItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports